














































































import { Component, Vue } from 'vue-property-decorator';
import InvestorGoalMovementsViewModel
  from '@/vue-app/view-models/components/goals-dashboard/linked-goals/investor-goal-movements-view-model';

@Component({
  name: 'InvestorGoalMovements',
  components: {
    RangePicker: () => import('@/vue-app/components/RangePicker.vue'),
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class InvestorGoalMovements extends Vue {
  view_model = Vue.observable(new InvestorGoalMovementsViewModel(this));

  created() {
    this.view_model.initialize();
  }
}
